// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Form, TextArea } from 'informed';

import {
  deleteChronicProblem,
  updateChronicProblem,
  deleteAcuteProblem,
  updateAcuteProblem,
} from '../../../actions/problemActions';

import DateText from '../../DateText.jsx';
import { Button, PrimaryButton, DeleteButton } from '../../Buttons.jsx';
import Typeahead from '../../Typeahead.jsx';
import ContentBox from '../../ContentBox.jsx';
import { PrimaryText, Label } from '../../Typography.jsx';

import styles from '../../../styles/patientPages/progressNote/progressNote.scss';

type Props = {
  activePatientId: string,
  activeAccount: Object,
  problem: Object,
  treatments: Object[],
  deleteChronicProblem: Function,
  updateChronicProblem: Function,
  deleteAcuteProblem: Function,
  updateAcuteProblem: Function,
}

type State = {
  editing: boolean,
}

class ProblemSummaryComponent extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      editing: false,
    };
  }

  formApi: {
    getState: Function,
  };

  setFormApi = (formApi: Object) => {
    this.formApi = formApi;
  }

  onCancel = () => {
    this.setState({
      editing: false,
    });
  }

  onEdit = () => {
    this.setState({
      editing: true,
    });
  }

  onSave = () => {
    const { invalid, values } = this.formApi.getState();
    if (invalid) {
      return;
    }
    values.onsetDate = moment(values.onsetDate, 'DD-MM-YYYY').toISOString();
    values.resolutionDate = moment(values.resolutionDate, 'DD-MM-YYYY').toISOString();

    const { activeAccount } = this.props;
    values.editor = `${activeAccount.name}, ${activeAccount.credential}`;
    values.editDate = moment().toISOString();

    const { problem } = this.props;
    if (problem.acute) {
      this.props.updateAcuteProblem(this.props.activePatientId,
        {
          problemId: problem._id,
          ...values,
        });
    } else if (problem.chronic) {
      this.props.updateChronicProblem(this.props.activePatientId,
        {
          problemId: problem._id,
          ...values,
        });
    }
    this.setState({
      editing: false,
    });
  }

  onDelete = () => {
    const { problem } = this.props;
    if (problem.acute) {
      this.props.deleteAcuteProblem(this.props.activePatientId, problem._id);
    } else if (problem.chronic) {
      this.props.deleteChronicProblem(this.props.activePatientId, problem._id);
    }
  }

  render() {
    const { problem, treatments } = this.props;
    const { editing } = this.state;

    return (
      <ContentBox title='Diagnosis Summary'>
        <Form getApi={this.setFormApi} autoComplete="off" >
          <table>
            <tbody>
              <tr className={styles.topAlign}>
                <td>
                  {editing
                    ? <Label>Diagnosis:</Label>
                    : <PrimaryText>{problem.diagnosis || '--'}</PrimaryText>
                  }
                </td>
                <td>
                  {editing && <Typeahead field='diagnosis' initialValue={problem.diagnosis} endpoint='diagnosis' />}
                </td>
              </tr>
              <tr className={styles.topAlign}>
                <td><Label>Date of onset:</Label></td>
                <td>{editing
                  ? <DateText field='onsetDate' item={problem} />
                  : problem.onsetDate ? moment(problem.onsetDate).format() : '--'}</td>
              </tr>
              <tr className={styles.topAlign}>
                <td><Label>Date of resolution: </Label></td>
                <td>{editing
                  ? <DateText field="resolutionDate" item={problem} nullable />
                  : problem.resolutionDate ? moment(problem.resolutionDate).format() : '(ongoing)'}</td>
              </tr>
              <tr className={styles.topAlign}>
                <td><Label>Treatments:</Label></td>
                <td>{treatments || '--'}</td>
              </tr>
              <tr className={styles.topAlign}>
                <td><Label>Details:</Label></td>
                <td>{editing
                  ? <TextArea field='details' initialValue={problem.details} />
                  : problem.details || '--'}</td>
              </tr>
              <tr className={styles.topAlign}>
                <td><Label>Notes:</Label></td>
                <td>{editing
                  ? <TextArea field='notes' initialValue={problem.notes} />
                  : problem.notes || '--'}</td>
              </tr>
            </tbody>
          </table>
          {editing
            ? (
              <div>
                <PrimaryButton onClick={this.onSave}>Save</PrimaryButton>
                <Button onClick={this.onCancel}>Cancel</Button>
              </div>
            ) : (
              <div>
                <PrimaryButton onClick={this.onEdit}>Edit</PrimaryButton>
                <DeleteButton
                  onClick={this.onDelete}
                  modalText={'Deleting a diagnosis will delete all associated treatments and progress notes'}
                >Delete</DeleteButton>
              </div>
            )
          }
        </Form>
      </ContentBox>
    );
  }
}

const mapStateToProps = state => ({
  activePatientId: state.patient.data.activePatientId,
  activeAccount: state.account.activeAccount,
});

const mapDispatchToProps = dispatch => ({
  deleteChronicProblem:
    (patientId, problemId) => dispatch(deleteChronicProblem(patientId, problemId)),
  updateChronicProblem: (patientId, problem) => dispatch(updateChronicProblem(patientId, problem)),
  deleteAcuteProblem:
    (patientId, problemId) => dispatch(deleteAcuteProblem(patientId, problemId)),
  updateAcuteProblem: (patientId, problem) => dispatch(updateAcuteProblem(patientId, problem)),
});

const ProblemSummary = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProblemSummaryComponent);

export default ProblemSummary;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/progressNote/ProblemSummary.jsx